import { TablesInsert } from "@/lib/supabase/supabase_types_override";
import { populateDefaultValuesForCrm } from "./populateDefaultValuesForCrm";
import { prepareConfigurationDataForInsert } from "./prepareConfigurationDataForInsert";

export function prepareCrmForInsert(data: TablesInsert<'crm'>): TablesInsert<'crm'> {
    let res = data;
    res = populateDefaultValuesForCrm(res);
    res = {
        ...res,
        configuration_data: prepareConfigurationDataForInsert(res.configuration_data!),
    }
    return res;
}